import { render, staticRenderFns } from "./BaseSingleSelect.vue?vue&type=template&id=32219050&scoped=true"
import script from "./BaseSingleSelect.vue?vue&type=script&lang=js"
export * from "./BaseSingleSelect.vue?vue&type=script&lang=js"
import style0 from "./BaseSingleSelect.vue?vue&type=style&index=0&id=32219050&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32219050",
  null
  
)

export default component.exports